import ExpenseByTeamService from "@/services/api/expenseByTeam";
import { handleResponse } from "@/services/axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

type ExpensePayload = {
  FromDate: string;
  ToDate: string;
};

export const fetchManagers = createAsyncThunk(
  "expenseByTeam/fetchManagers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ExpenseByTeamService.fetchManagers();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(error?.Message ?? "Failed to fetch managers data");
    }
  },
);

export const fetchReportsByTeam = createAsyncThunk(
  "expenseByTeam/fetchReportsByTeam",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await ExpenseByTeamService.fetchReportsByTeam(payload);
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message ?? "Failed to fetch reports by team data",
      );
    }
  },
);

export const fetchTeamWithGCDetail = createAsyncThunk(
  "expenseByTeam/fetchTeamWithGCDetail",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response =
        await ExpenseByTeamService.fetchTeamWithGCDetail(payload);
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message ?? "Failed to fetch team with GC Details",
      );
    }
  },
);

export const expenseReportByTeam = createAsyncThunk<any, ExpensePayload>(
  "expenseByTeam/expenseReportByTeam",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ExpenseByTeamService.expenseReportByTeam(payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error?.Message ?? "Failed to export Report by team",
      );
    }
  },
);

const initialState = {
  reportByTeam: [],
  managers: [],
  myTeamWithGcDetail: [],
};

const expenseByTeamSlice = createSlice({
  name: "expenseByTeam",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTeamWithGCDetail.fulfilled, (state, action) => {
      state.myTeamWithGcDetail = action.payload;
    });
    builder.addCase(fetchReportsByTeam.fulfilled, (state, action) => {
      state.reportByTeam = action.payload;
    });
    builder.addCase(fetchManagers.fulfilled, (state, action) => {
      state.managers = action.payload;
    });
  },
});

export default expenseByTeamSlice.reducer;
